import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Button, Typography } from "@mui/material";
import { Translate } from "orion-components/i18n";
import SpriteIcon from "orion-components/SharedComponents/SpriteIcon/SpriteIcon";
import { verifyDetection } from "../../../SharedActions/commonActions";

const propTypes = {
    sensorop: PropTypes.object,
    metadata: PropTypes.object,
    externalSystemId: PropTypes.string
};

const defaultProps = {
    sensorop: {},
    externalSystemId: "sensorops-detections"
};

const SensorOPDetectionWidget = ({ sensorop, metadata, alertId, externalSystemId }) => {
    const dispatch = useDispatch();

    const { classification, image, eventId } = sensorop;
    const feedbackSubmitted = metadata?.sensorop?.feedbackSubmitted;

    const styles = {
        label: {
            fontSize: 13,
            color: "#fff"
        },
        image: {
            maxWidth: "100%"
        },
        feedback: {
            display: "flex",
            alignItems: "center",
            margin: "10px 0px"
        },
        submitted: {
            fontSize: 12,
            color: "#fff",
            margin: "0 8px"
        }
    };

    return (
        <div>
            <div style={{ width: "75%", lineHeight: "48px" }}>
                <img
                    alt={`image_${classification}`}
                    style={styles.image}
                    src={image}
                />
            </div>
            <div>
                <div>
                    <Typography style={styles.label}>
                        <Translate value="global.profiles.widgets.sensorOPDetection.classification" count={classification} />
                        <span style={{ margin: "0 5px", textTransform: "uppercase" }}>{feedbackSubmitted}</span>
                    </Typography>
                </div>
                {feedbackSubmitted ?
                    <div style={styles.feedback}>
                        <SpriteIcon
                            iconName={"icon_check-circle-outline"}
                            customHeight="22px"
                            customWidth="22px"
                        />
                        <Typography style={styles.submitted}>
                            <Translate value="global.profiles.widgets.sensorOPDetection.feedbackSubmitted" />
                        </Typography>
                    </div>
                    :
                    <div style={{ lineHeight: "48px" }}>
                        <Button
                            style={{
                                height: 25,
                                color: "#fff",
                                width: 50,
                                padding: 0,
                                fontSize: 12,
                                margin: "0px",
                                borderRadius: "8px",
                                minWidth: "unset"
                            }}
                            sx={{
                                "&:hover": {
                                    backgroundColor: "#85C7EF !important"
                                }
                            }}
                            onClick={() => dispatch(verifyDetection(externalSystemId, eventId, "yes", alertId))}
                            variant="contained"
                            color="primary"
                        >
                            <Translate value="global.profiles.widgets.sensorOPDetection.yes" />
                        </Button>
                        <Button
                            style={{
                                height: 25,
                                color: "#fff",
                                width: 50,
                                padding: 0,
                                fontSize: 12,
                                margin: "0px 25px",
                                borderRadius: "8px",
                                minWidth: "unset"
                            }}
                            sx={{
                                "&:hover": {
                                    backgroundColor: "#85C7EF !important"
                                }
                            }}
                            onClick={() => dispatch(verifyDetection(externalSystemId, eventId, "no", alertId))}
                            variant="contained"
                            color="primary"
                        >
                            <Translate value="global.profiles.widgets.sensorOPDetection.no" />
                        </Button>
                    </div>
                }
            </div>
        </div >
    );
};

SensorOPDetectionWidget.propTypes = propTypes;
SensorOPDetectionWidget.defaultProps = defaultProps;

export default SensorOPDetectionWidget;